<template>
  <div :class="[$style.config, $style.card]" aria-hidden="true">
    <div :class="$style.imageWrapper">
      <div :class="$style.imageSkeleton" />
    </div>
    <div :class="$style.contentContainer">
      <div :class="$style.titleSkeleton" />
    </div>
  </div>
</template>

<style lang="scss" module>
.config {
}

.card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 232px;
  max-width: 100%;
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.imageWrapper {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 18px 12px;
  background:
    radial-gradient(circle at top, rgba(92, 102, 191, 0.08), transparent 60%),
    linear-gradient(180deg, #fff 0%, #fafafa 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.imageSkeleton,
.titleSkeleton {
  position: relative;
  overflow: hidden;
  background: #eef0f5;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.7) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: shimmer 1.5s ease-in-out infinite;
  }
}

.imageSkeleton {
  width: 95%;
  height: 95%;
  border-radius: 12px;
}

.contentContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px 16px 18px;
}

.titleSkeleton {
  width: 95%;
  height: 22px;
  border-radius: 999px;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
